import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
  SENTIMENTS_EMOTIONS_CHART_MAP_OPTIONS
} from './constants/HighchartsConstants';

class Minichart extends Component {

    constructor(props) {
      super(props);
      this.state = {
        mapOptions: {...SENTIMENTS_EMOTIONS_CHART_MAP_OPTIONS},
      };
    }

    UNSAFE_componentWillReceiveProps(_newProps) {
      let { mapOptions } = this.state;
      this.setState({ mapOptions });
    }
  
    render() {
      const { mapOptions } = this.state;
      return (
        <React.Fragment>
          {mapOptions.series && mapOptions.series.length > 0 && (
            <HighchartsReact
              highcharts={Highcharts}
              options={mapOptions}
              allowChartUpdate={true}
              immutable={false}
              updateArgs={[true, true, true]}
            />
          )}
        </React.Fragment>
      );
    }
}

export default Minichart;


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/MiniChart.js